import $ from 'jquery';
import formatButtons from './formatButtons';

export default () => {
  $(document).on('shopify:section:load', (e) => {
    formatButtons(`[data-section-id="${e.detail.sectionId}"]`);
  });
};